import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { ReactComponent as Close } from "../../../assets/images/teamclose.svg";
import Input from "../../common/InputField";
import { updateTicket } from "../../../store/features/updateTicket";
import { getTicketById, updateTicketSubject } from "../../../store/features/getTicketById";


function EditSubjectPopup({ open, onClose, ticketId, initialSubject = "", onSaved }) {
  const dispatch = useDispatch();
  const [subject, setSubject] = useState(initialSubject);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setSubject(initialSubject || "");
    }
  }, [open, initialSubject]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = subject.trim();
    if (!trimmed) {
      toast.error("Subject cannot be empty");
      return;
    }
    if (trimmed.length > 64) {
      toast.error("Subject cannot exceed 64 characters");
      return;
    }
    if (!ticketId) return;
    setLoading(true);
    try {
      await dispatch(
        updateTicket({
          ticketId,
          updateData: { subject: trimmed },
        })
      ).unwrap();
      dispatch(updateTicketSubject({ subject: trimmed }));
      await dispatch(getTicketById({ ticketId, silent: true }));
      toast.success("Subject updated");
      onSaved?.();
      onClose();
    } catch (err) {
      const msg =
        err?.data?.message || err?.message || "Failed to update subject";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const disableSave =
    loading || !subject.trim() || subject.trim() === (initialSubject || "").trim();

  return (
    <>
      <div className="overlay" />
      <div className="Team-PopUp-Container" style={{ maxWidth: "424px" }}>
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">Edit Subject</p>
          <p className="PopUp-Text02" onClick={onClose} style={{ cursor: "pointer" }}>
            <Close />
          </p>
        </div>
        <form className="PopUp-Email-Container" onSubmit={handleSubmit}>
          <Input
            type="text"
            placeholder="Enter new subject"
            title="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <div className="Ticket-Button-Container">
            <button
              className="buttonstyle-Cancel"
              type="button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="buttonstyle-Ticket"
              type="submit"
              disabled={disableSave}
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default EditSubjectPopup;
